import { render, staticRenderFns } from "./foreignStateTotal.vue?vue&type=template&id=db10c73e&scoped=true&"
import script from "./foreignStateTotal.vue?vue&type=script&lang=js&"
export * from "./foreignStateTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db10c73e",
  null
  
)

export default component.exports